import { DadosClienteProps } from "../../types/DadosClienteProps";
import InputMask from 'react-input-mask'

export function DadosEntregas({ register, cliente, inputDisabled } : DadosClienteProps){
  return(
    <>
      <div className="w-full">
        <label className="font-[500]" htmlFor="EnderecoEntregaLogradouro">Logradouro</label>
        <input 
          type="text"
          {...register("EnderecoEntregaLogradouro")}
          defaultValue={cliente?.EnderecoEntregaLogradouro}
          disabled={inputDisabled}
          name="EnderecoEntregaLogradouro"
          maxLength={150}
          className="input-login-style w-full mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
        />
      </div>
      <div className="flex flex-row flex-wrap justify-between">
        <div>
          <label className="font-[500]" htmlFor="EnderecoEntregaCidade">Cidade</label>
          <input 
            type="text"
            {...register("EnderecoEntregaCidade")}
            defaultValue={cliente?.EnderecoEntregaCidade}
            disabled={inputDisabled}
            name="EnderecoEntregaCidade"
            maxLength={50}
            className="input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
          />
        </div>
        <div>
          <label className="font-[500]" htmlFor="EnderecoEntregaEstado">Estado</label>
          <input 
            type="text"
            {...register("EnderecoEntregaEstado")}
            defaultValue={cliente?.EnderecoEntregaEstado}
            disabled={inputDisabled}
            name="EnderecoEntregaEstado"
            maxLength={50}
            className="input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
          />
        </div>
        <div>
          <label className="font-[500]" htmlFor="EnderecoEntregaCEP">CEP</label>
          <InputMask
            type="text"
            mask={"99999-999"}
            {...register("EnderecoEntregaCEP")}
            defaultValue={cliente?.EnderecoEntregaCEP}
            disabled={inputDisabled}
            name="EnderecoEntregaCEP"
            className="input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
          />
        </div>
        <div>
          <label className="font-[500]" htmlFor="EnderecoEntregaPais">País</label>
          <input 
            type="text"
            {...register("EnderecoEntregaPais")}
            defaultValue={cliente?.EnderecoEntregaPais}
            disabled={inputDisabled}
            name="EnderecoEntregaPais"
            maxLength={50}
            className="input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
          />
        </div>
      </div>
    </>
  );
}
